import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface ResetCustomsReportParams {
  batchId: string;
  hardReset?: boolean;
}

export const useResetCustomsReport = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ batchId, hardReset }: ResetCustomsReportParams) => {
      return request({
        path: `admin/batch-reset-customs-report/${batchId}`,
        method: 'PATCH',
        authenticate: true,
        dataObject: { hardReset },
      });
    },
    onSuccess: () => {
      toast.success('Customs report reseted!');
      queryClient.invalidateQueries({ queryKey: ['admin-batches'] });
    },
    onError: (error: any) => {
      showErrorToast(error, 'Error reseting customs report!');
    },
  });
};
